module.exports = __webpack_public_path__ + "static/media/Fontfabric - MullerLightItalic.cef1a6b5.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Fontfabric - MullerLightItalic.otf
// module id = 1068
// module chunks = 0